<template>
<div
	v-if="!isPopupOpen || !inModal"
	class="row align-items-center p-0 m-0"
	style="height: 100%;"
>
	<div
		v-if="showStation"
		class="g-0 m-0 gx-2 pb-2"
		:class="{
			'col-9 mx-3': !inModal,
			'col-12': inModal,
		}"
	>
		<legend v-if="!inModal" class="text-center text-nowrap pb-2">
			Запит опитування станції
		</legend>
		<p class="my-0">
			<i>Наразі станція опитується кожні {{ stationSurveyPeriod }}.</i><br>
		</p>
		<Transition name="description">
			<p v-if="showDescription" class="my-0 paragraph-indent">
				Натиснувши <b>"Опитати зараз"</b> ви спровокуєте позачергове опитування станції.<br>
				Після такого опитування наступне відбудеться через визначенний в налаштуваннях період.
			</p>
		</Transition>
	</div>

	<div
		v-if="showStation"
		class="me-0"
		:class="{
			'col-2': !inModal,
			'col-12': inModal,
		}"
	>
		<div
			class="row g-0 p-0 m-0"
			:class="{
				'justify-content-end': !inModal,
				'justify-content-center': inModal,
			}"
		>
			<div class="col-auto">
				<button
					class="btn btn-primary btn-sm"
					@click="onSubmit('station')"
					:disabled="!isEnabled"
				>
					<span
						v-if="isPopupOpen"
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
					>
					</span>
					Опитати&nbsp;зараз
				</button>
			</div>
		</div>
	</div>

	<div
		v-if="showStation && showElectricMeter"
		class="col-12 gx-2 p-2"
	>
		<hr class="hr m-0 px-2 py-0" />
	</div>

	<div
		v-if="showElectricMeter && format == 'full'"
		class="g-0 m-0 gx-2 pb-2"
		:class="{
			'col-9 mx-3': !inModal,
			'col-12': inModal,
		}"
	>
		<legend v-if="!inModal" class="text-center text-nowrap pb-2">
			Запит опитування електролічильника
		</legend>
		<p class="my-0">
			<i>Наразі електролічильник опитується кожні {{ electricMeterSurveyPeriod }}.</i><br>
		</p>
		<p v-if="showDescription" class="my-0 paragraph-indent">
			Натиснувши <b>"Опитати зараз"</b> ви спровокуєте позачергове опитування електролічильника.<br>
			Після такого опитування наступне відбудеться згідно встановленого графіка. Тобто графік опитування не порушиться.
		</p>
		<div
			v-if="!station?.electricMeterIsSeparateUnit"
			class="text-secondary my-0 mt-2 py-0"
		>
			*&nbsp;Обраний тип електролічильника не може виконати цю дію. Доступно тільки для NIK/DLMS лічильників.
		</div>
	</div>

	<div
		v-if="showElectricMeter && format == 'full'"
		class="me-0"
		:class="{
			'col-2': !inModal,
			'col-12': inModal,
		}"
	>
		<div
			class="row g-0 p-0 m-0"
			:class="{
				'justify-content-end': !inModal,
				'justify-content-center': inModal,
			}"
		>
			<div class="col-auto">
				<button
					class="btn btn-primary btn-sm"
					@click="onSubmit('electric_meter')"
					:disabled="!isEnabled || !station?.electricMeterIsSeparateUnit"
				>
					<span
						v-if="isPopupOpen"
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
					>
					</span>
					Опитати&nbsp;зараз
				</button>
			</div>
		</div>
	</div>

	<div
		v-if="showElectricMeter && format == 'short'"
		class="row row-col-1 g-0 m-0 mx-1 px-2 py-0"
	>
		<div class="row m-0 p-0 g-0">
			<span class="tile-title px-2 py-0 m-0 text-center text-wrap">
				Запит опитування електролічильника
			</span>
		</div>
		<div class="row m-0 p-0 mt-1">
			<div class="col-6 mx-0 ps-2 text-start metric-name-text">Період опитування</div>
			<div class="col-6 mx-0 pe-2 text-end metric-value-text">{{ electricMeterSurveyPeriod }}</div>
		</div>
		<div class="row m-0 p-0">
			&nbsp;
		</div>
		<div class="row justify-content-center g-0 p-0 m-0 mt-2">
			<div class="col-auto">
				<button
					class="btn btn-primary btn-sm"
					@click="onSubmit('electric_meter')"
					:disabled="!isEnabled || !station?.electricMeterIsSeparateUnit"
				>
					<span
						v-if="isPopupOpen"
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
					>
					</span>
					Опитати зараз
				</button>
			</div>
		</div>
	</div>

	<div class="col-12 my-0 mx-3 mb-1 py-0">
		<div id="valueHelpBlock" class="form-text">
			<p :class="helpPromtClass" class="mb-0">
				{{ helpPromt }}&nbsp;
			</p>
		</div>
	</div>
</div>
	
<!-- Modal -->
<confirmation-popup
	v-model:show="isPopupOpen"
	:confirm-button-title="isLoading || isError || allRpcs.length > 0 ? '' : 'Так'"
	:reject-button-title="isLoading || isError || allRpcs.length > 0 ? 'Закрити' : 'Ні'"
	@confirm="makeRequest()"
>
	<template v-if="station.isActive" v-slot:body>
		<template v-if="isLoading">
			<span
				class="spinner-border spinner-border-sm"
				role="status"
				aria-hidden="true"
			>
			</span>
			Перевірка активних задач телекерування
		</template>
		<template v-else-if="isError">
			Помилка при перевірці активних задач телекерування, закрийте і спробуйте ще.
		</template>
		<template v-else>
			<template v-if="allRpcs.length > 0">
				Станція зараз обробляє інший запит 
				("{{ rpcTaskSchema.job.findJob(allRpcs[0][rpcTaskSchema.job.key]).title }}"). 
				Будь ласка дочекайтесь його виконання.
			</template>
			<template v-else>
				Запустити опитування 
				{{ surveyObject == 'station' ? 'станції' : '' }}
				{{ surveyObject == 'electric_meter' ? 'електролічильника' : '' }} 
				зараз?
			</template>
		</template>
	</template>
	<template v-else v-slot:body>
		Станція не активна. Тільки активні станції виконують запити.
	</template>
</confirmation-popup>
</template>




<script>
import ConfirmationPopup from "@/components/ConfirmationPopup.vue"
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import {
	rpcTaskSchema,
	stationManageJobs,
	useRpcTasks,
} from '@/composables/rpcTasks.js'
import { Station } from '@/models/station.js'
// import { ElectricMeter } from "@/models/electricMeter.js"
import { verboseTimePeriod } from '@/helpers.js'


export default {
	components: {
		ConfirmationPopup,
	},

	props: {
		isEnabled: {
			type: Boolean,
			required: false,
			default: true,
		},
		showStation: {
			type: Boolean,
			required: false,
			default: true,
		},
		showDescription: {
			type: Boolean,
			required: false,
			default: true,
		},
		showElectricMeter: {
			type: Boolean,
			required: false,
			default: true,
		},
		inModal: {
			type: Boolean,
			required: false,
			default: false,
		},
		format: { // 'full' of 'short'
			type: String,
			required: false,
			default: 'full',
		},
		stationId: {
			type: String,
			required: true,
		},
	},

	emits: {
		// Request creation result
		requestResult: value => typeof value === 'boolean',
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const {
			allRpcs,
			isLoading,
			isError,
			setFilters,
			createRpc,
		} = useRpcTasks()

		return {
			Station,
			
			accountStore,
			stationsStore,

			rpcTaskSchema,
			allRpcs,
			isLoading,
			isError,
			setFilters,
			createRpc,
			
		}
	},

	data() {
		return {
			surveyObject: null, // 'station' or 'electric_meter'
			// Confirmation popup
			isPopupOpen: false,

			// Help promt
			helpPromtClass: '',
			helpPromt: '',
		}
	},

	mounted () {},

	methods: {
		onSubmit (surveyObject) {
			this.surveyObject = surveyObject
			// Begin fetching active tasks
			this.checkActiveTask()
			this.isPopupOpen = true
		},

		checkActiveTask() {
			this.setFilters({
				destinationStationIds: [this.stationId, ],
				isComplete: false,
				jobs: stationManageJobs,
			})
		},

		async makeRequest () {
			if (this.isLoading || this.isError || this.allRpcs.length > 0) {
				return
			}

			const result = await this.writeRpc()
			this.$emit('requestResult', Boolean(result))
		},

		async writeRpc() {
			let job = null
			switch (this.surveyObject) {
				case 'station':
					job = rpcTaskSchema.job.allowed.doSurveyNow.key
					break
				case 'electric_meter':
					job = rpcTaskSchema.job.allowed.doElectricMeterSurveyNow.key
					break
				default:
					this.printErr('Сталася помилка. Невідомий об\'єкт опитування.')
					return false
			}
			return await this.createRpc(
				this.accountStore.userId,
				job,
				this.stationId
			).then((result) => {
				if (result) {
					this.printHint('Запит надіслано. Спостерігайте за його станом.')
				} else {
					this.printErr('Сервер відхилив запит постановки завдання.')
				}

				return result
			})
		},

		printHint (msg) {
			this.helpPromtClass = "text-secondary"
			this.helpPromt = msg
		},

		printErr (msg) {
			this.helpPromtClass = "text-danger"
			this.helpPromt = msg
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		stationSurveyPeriod() {
			let period = null
			if (this.station.passport.has(Station.passportKeys.surveyPeriod)) {
				period = this.station.passport.get(Station.passportKeys.surveyPeriod);
			} else {
				return null
			}

			return verboseTimePeriod(period)
		},

		electricMeterSurveyPeriod() {
			let period = null
			if (this.station.passport.has(Station.passportKeys.electricMeter.self)) {
				period = this.station.passport.get(Station.passportKeys.electricMeter.self)
				period = period[Station.passportKeys.electricMeter.surveyPeriod]
			} else {
				return null
			}

			return verboseTimePeriod(period)
		},
	},
}
</script>




<style src="@/assets/stationForm.css" scoped></style>
<style src="@/assets/widget.css" scoped></style>
<style scoped>
</style>